import React from "react";

import {
  Content,
  Gallery,
  GalleryItem,
  Grid,
  GridItem,
  List,
  ListItem,
  PageSection,
  Stack,
  StackItem
} from "@patternfly/react-core";

import {
  ProjectInfoCard,
  ProjectPageHeader,
  ProjectSection
} from "apps/school-site/features/projects";

import {
  remoteWyrzyskEffects,
  remoteWyrzyskGallery,
  remoteWyrzyskGoal,
  remoteWyrzyskProject,
  remoteWyrzyskScope,
  remoteWyrzyskTasks
} from "./data/remoteWyrzyskProjectData";


const RemoteWyrzyskProjectPage = () => {
  return (
    <PageSection isWidthLimited>
      <Stack hasGutter>
        <StackItem>
          <ProjectPageHeader
            title="Zdalny Wyrzysk"
            description="Kształcenie zawodowe w trakcie pandemii w Powiecie Pilskim."
          />
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectInfoCard
                title={remoteWyrzyskProject.title}
                description={remoteWyrzyskProject.description}
                image={remoteWyrzyskProject.image}
              >
                <Content>
                  <p>
                    <strong>Numer projektu:</strong>{" "}
                    {remoteWyrzyskProject.projectNumber}
                  </p>

                  <p>
                    <strong>Okres realizacji:</strong>{" "}
                    {remoteWyrzyskProject.period}
                  </p>

                  <p>
                    <strong>
                      Całkowita wartość projektu:
                    </strong>{" "}
                    {remoteWyrzyskProject.value}
                  </p>

                  <p>
                    <strong>
                      Wkład Funduszy Europejskich:
                    </strong>{" "}
                    {remoteWyrzyskProject.funding}
                  </p>

                  <p>
                    <strong>
                      Projekt realizowany w ramach:
                    </strong>
                  </p>

                  <List isPlain>
                    {remoteWyrzyskProject.programme.map(
                      (item) => (
                        <ListItem key={item}>
                          {item}
                        </ListItem>
                      )
                    )}
                  </List>
                </Content>
              </ProjectInfoCard>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Cel projektu">
                <Content>
                  <p>
                    {remoteWyrzyskGoal}
                  </p>
                </Content>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Projekt polegał na">
                <Content>
                  <List>
                    {remoteWyrzyskScope.map((item) => (
                      <ListItem key={item}>
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Content>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Efekty projektu">
                <Content>
                  <List>
                    {remoteWyrzyskEffects.map((item) => (
                      <ListItem key={item}>
                        {item}
                      </ListItem>
                    ))}
                  </List>
                </Content>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        <StackItem>
          <Grid>
            <GridItem
              span={12}
              md={10}
              mdOffset={1}
            >
              <ProjectSection title="Zadania">
                <Stack hasGutter>
                  {remoteWyrzyskTasks.map((task) => (
                    <StackItem key={task.id}>
                      <ProjectSection
                        title={`Zadanie ${task.number}. ${task.title}`}
                      >
                        <Content>
                          <p>
                            <strong>
                              Okres realizacji:
                            </strong>{" "}
                            {task.period}
                          </p>

                          <p>
                            <strong>
                              Miejsce realizacji:
                            </strong>{" "}
                            {task.location}
                          </p>

                          <p>
                            {task.description}
                          </p>

                          {task.items?.length > 0 && (
                            <List>
                              {task.items.map((item) => (
                                <ListItem key={item}>
                                  {item}
                                </ListItem>
                              ))}
                            </List>
                          )}
                        </Content>
                      </ProjectSection>
                    </StackItem>
                  ))}
                </Stack>
              </ProjectSection>
            </GridItem>
          </Grid>
        </StackItem>

        {remoteWyrzyskGallery.length > 0 && (
          <StackItem>
            <Grid>
              <GridItem
                span={12}
                md={10}
                mdOffset={1}
              >
                <ProjectSection title="Galeria">
                  <Gallery
                    hasGutter
                    minWidths={{
                      default: "220px"
                    }}
                  >
                    {remoteWyrzyskGallery.map((image) => (
                      <GalleryItem key={image.id}>
                        <img
                          src={image.src}
                          alt={image.alt}
                          loading="lazy"
                          style={{
                            display: "block",
                            width: "100%",
                            height: "220px",
                            objectFit: "cover"
                          }}
                        />
                      </GalleryItem>
                    ))}
                  </Gallery>
                </ProjectSection>
              </GridItem>
            </Grid>
          </StackItem>
        )}
      </Stack>
    </PageSection>
  );
};

export default RemoteWyrzyskProjectPage;